module.exports = __webpack_public_path__ + "img/avatar.1d4564c7.png";